import React, { useState, useEffect, useCallback } from 'react';
import './Herosection.css';
import hero1 from '../../assets/hp1.svg';
import hero2 from '../../assets/hp2.svg';
import hero3 from '../../assets/hp3.svg';
import commitement from '../../assets/commitment.jpg';
import ShapeFuture from '../../assets/shapingFuture.svg'
import { Link } from 'react-router-dom';


const Herosection = () => {
    const slides = [
        {
            image: hero1,
            title: 'Our Philosophy',
            subtitle: 'Services should reduce complexity, not add to it. Delivery teams must be accountable for outcomes, not effort.This philosophy shapes how blukraft operates—with customers, partners, and internal teams.',
            caption: 'Our Philosophy',
            showButton: true
        },
        {
            image: hero2,
            title: 'Why blukraft',
            subtitle: 'blukraft fixes great platforms failure from poor execution. risposta®s services arm, we merge product expertise with accountable delivery. Committed to measurable value via governance, management, and quality—forging trusted partnerships for efficiency, resilience, and performance globally.',
            caption: 'Why blukraft',
            showButton: true
        },
        {
            image: hero3,
            title: 'Innovating With Purpose',
            subtitle: 'At blukraft, delivery is not a phase — it is a responsibility.',
            caption: 'Innovating With Purpose',
            showButton: true
        }
    ];

   const [current, setCurrent] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);

    // Optimized progress animation using requestAnimationFrame
    const updateProgress = useCallback((timestamp) => {
        setCurrent((prev) => {
            const nextSlide = (prev + 1) % slides.length;
            setCurrent(nextSlide);
            return nextSlide;
        });
    }, [slides.length]);

    useEffect(() => {
        let animationFrame;
        let startTime;

        const animate = (timestamp) => {
            if (!isAutoPlaying) return;

            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;

            if (elapsed > 10000) { // 5 second per slide
                updateProgress(timestamp);
                startTime = timestamp;
            }

            animationFrame = requestAnimationFrame(animate);
        };

        if (isAutoPlaying) {
            animationFrame = requestAnimationFrame(animate);
        }

        return () => {
            if (animationFrame) {
                cancelAnimationFrame(animationFrame);
            }
        };
    }, [isAutoPlaying, updateProgress]);

    const goToSlide = useCallback((index) => {
        setCurrent(index);
        setIsAutoPlaying(false);
    }, []);

    const toggleAutoPlay = () => {
        setIsAutoPlaying(prev => !prev);
    };

    return (
        <>
            <div className="hero-wrapper" role="region" aria-label="Hero slideshow">
                {/* Background slides */}
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`hero-slide ${index === current ? 'hero-active' : ''}`}
                        style={{ backgroundImage: `url(${slide.image})` }}
                        role="img"
                        aria-label={slide.caption}
                    />
                ))}
                
             {/* Content overlay - WHITE TEXT */}
                <div className="hero-overlay" aria-live="polite">
                    <h1 className="hero-title1">{slides[current].title}</h1>
                    <p className="hero-subtitle">{slides[current].subtitle}</p>
                </div>


                {/* Progress indicators */}
                <div className="hero-progress-bar-container" role="tablist">
                    {slides.map((slide, index) => (
                        <div
                            key={index}
                            className={`hero-progress-bar-wrapper ${index === current ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                            role="tab"
                            aria-selected={index === current}
                            aria-controls={`slide-${index}`}
                            title={slide.caption}
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    goToSlide(index);
                                }
                            }}
                        >
                            <div className="hero-progress-bar">
                                <div
                                    className="hero-progress"
                                    style={{ 
                                        width: index === current ? '100%' : '0%',
                                        transition: index === current ? 'width 10s linear' : 'none'
                                    }}
                                />
                            </div>
                            <p className="hero-caption" style={{fontFamily: "Sansation_Regular", fontSize: "20px"}}>
                                {slide.caption}
                            </p>
                        </div>
                    ))}
                </div>

                {/* Autoplay toggle button */}
                <button
                    className="hero-autoplay-toggle"
                    onClick={toggleAutoPlay}
                    aria-label={isAutoPlaying ? 'Pause slideshow' : 'Play slideshow'}
                >
                    {isAutoPlaying ? '⏸️' : '▶️'}
                </button>
            </div>

            {/* Static content section */}
            <section className="hero-content-section" aria-labelledby="future-heading">
                <div className="row">
                    <div className="col-12 col-md-12 col-lg-6">
                        <div className="hero-content-text" style={{fontFamily: "Sansation_Regular"}}>
                            <h2 id="future-heading">Shaping the Future</h2>
                            <p>
                                Our services span the full transformation lifecycle—from diagnostics and strategy to 
                                implementation and long-term operations—powered by AI, ML, and automation.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6">
                        <Link to="#" aria-label="Learn more about shaping the future">
                            <img src={ShapeFuture} alt="Shaping the future with technology" className="hero-content-image" />
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Herosection;
